<template>
  <div>
    <Header></Header>
    <!-- 身体 -->
    <div class="banner">
      <el-carousel
        class="banner-left"
        trigger="click"
        ref="carousel"
        indicator-position="none"
        height="400px"
        :autoplay="false"
      >
        <el-carousel-item v-for="(banner,index) in banner1" :key="index">
          <a v-if="banner.type==5" :href="banner.url">
            <img :src="banner.pc_image" alt />
          </a>
          <img v-if="banner.type==0" :src="banner.pc_image" alt />
          <router-link :to="{path:'/details',query: {id: banner.course_id}}" v-if="banner.type==1">
            <img :src="banner.pc_image" alt />
          </router-link>
          <router-link :to="{path:'/huodong',query: {id:banner.id}}" v-if="banner.type==2">
            <img :src="banner.pc_image" alt />
          </router-link>
          <router-link
            :to="{path:'/advi_details',query: {id: banner.consultteacher_id}}"
            v-if="banner.type==3"
          >
            <img :src="banner.pc_image" alt />
          </router-link>
          <router-link
            :to="{path:'/evalu_details',query: {id: banner.appraisal_id}}"
            v-if="banner.type==4"
          >
            <img :src="banner.pc_image" alt />
          </router-link>
        </el-carousel-item>
      </el-carousel>

      <!--
      <div class="banner-right">
        <ul>
          <li v-for="(banner,index) in banner1" :key="index" @mouseenter="tab(index)">
            <a v-if="banner.type==5" :href="banner.url">{{banner.name}}</a>
            <router-link
              :to="{path:'/details',query: {id: banner.course_id}}"
              v-if="banner.type==1"
            >{{banner.name}}</router-link>
            <router-link
              :to="{path:'/huodong',query: {id: banner.id}}"
              v-if="banner.type==2"
            >{{banner.name}}</router-link>
            <router-link
              :to="{path:'/advi_details',query: {id: banner.consultteacher_id}}"
              v-if="banner.type==3"
            >{{banner.name}}</router-link>
            <router-link
              :to="{path:'/evalu_details',query: {id: banner.appraisal_id}}"
              v-if="banner.type==4"
            >{{banner.name}}</router-link>
          </li>
        </ul>
      </div>
      -->
    </div>
    <!-- 搜索结果 -->
    <div v-show="a==1">
      <div class="s_cont">
        <div class="nav">
          <div class="left">
            <ul>
              <li
                v-for="(tab,index) in tabs"
                :key="index"
                @click="toggle(index,tab.id)"
                :class="{active:active==index}"
              >{{tab.name}}</li>
            </ul>
          </div>
        </div>
        <div>
          <input
            class="search"
            placeholder="全局搜索"
            @blur="blur"
            @focus="focus"
            type="text"
            v-model="search"
          />
          <div class="search_img">
            <img @click="gosearch" src="../assets/img/search_n.png" alt />
          </div>
          <div class="h_search" v-show="show==1">
            <div class="top">
              <p>历史搜索</p>
              <p @click="deletes">
                <img src="../assets/img/search_del.png" alt /> 清空
              </p>
            </div>
            <div class="jieguo">
              <p v-for="(list , index) in h_search" :key="index" @click="xz(list)">{{list}}</p>
              <p v-show="!h_search">无</p>
            </div>
          </div>
        </div>
      </div>
      <!-- 课程 -->
      <div class="Course" v-show="active==0">
        <div class="details">
          <div
            class="list"
            v-for="(good,index) in good_courses1"
            :key="index"
            @click="godetails(good.id,index)"
          >
            <img :src="good.image" alt />
            <p class="title">{{good.name}}</p>
            <div class="jiage">
              <img class="touxiang" :src="good.teacher_image" alt />
              <p class="name">{{good.teacher_name}}</p>
              <p class="price" v-if="good.members_free==1">VIP免费</p>
              <p class="price" v-if="good.price!=0.00&&good.members_free==0">¥{{good.price}}</p>
              <p class="price" v-if="good.price==0.00">免费</p>
            </div>
            <div class="solid"></div>
            <div class="list-footer">
              <div class="left">
                <img src="../assets/img/se.png" alt />
                <span>{{good.sales}}</span>
              </div>
              <div class="center"></div>
              <div class="right">
                <img src="../assets/img/pl.png" alt />
                <span>{{good.number}}</span>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="good_courses1.length==0"
          style="margin:0 auto;width:800px;text-align:center;margin-bottom:14px;"
        >无</div>
        <div style="margin:0 auto;width:800px;text-align:center;margin-bottom:14px;">
          <el-pagination
            background
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-size="pageSize"
            layout=" prev, pager, next"
            :total="totalNum"
          ></el-pagination>
        </div>
      </div>
      <!-- 老师 -->
      <div v-show="active==1">
        <div
          class="topic"
          v-for="(list,index) in lists1"
          :key="index"
          @click="got_details(list.id)"
        >
          <div class="topic-left">
            <img class="left-img" :src="list.avatar" alt />
            <div class="topic-left-right">
              <div class="name">{{list.nickname}}</div>
              <img src="../assets/img/jiangs.png" alt />
              <span class="chenghu">{{list.the_title}}</span>
              <div class="jianjie">{{list.intro}}</div>
            </div>
          </div>
          <img
            v-for="(data,index) in list.data"
            :key="index"
            class="topic-img"
            :src="data.image"
            alt
          />
        </div>
        <div
          v-if="lists1.length==0"
          style="margin:0 auto;width:800px;text-align:center;margin-bottom:14px;"
        >无</div>
        <div style="margin:0 auto;width:800px;text-align:center;margin-bottom:14px;">
          <el-pagination
            background
            @current-change="handleCurrentChange1"
            :current-page="currentPage1"
            :page-size="pageSize1"
            layout=" prev, pager, next"
            :total="totalNum1"
          ></el-pagination>
        </div>
      </div>
      <!-- 评测 -->
      <div class="cont" v-show="active==2">
        <div class="list" @click="godetails(list.id)" v-for="(list,index) in lists2" :key="index">
          <div class="list-cont">
            <div>
              <img :src="list.image" alt />
            </div>
            <div class="right">
              <div class="name">{{list.name}}</div>
              <p class="price" v-if="list.members_free==1">VIP免费</p>
              <p class="price" v-if="list.price!=0.00&&list.members_free==0">¥{{list.price}}</p>
              <p class="price" v-if="list.price==0.00&&list.members_free!=1">免费</p>
            </div>
          </div>
        </div>
        <div
          style="margin:0 auto;width:800px;text-align:center;margin-bottom:14px;"
          v-if="lists2.length==0"
        >无</div>
        <div style="margin:0 auto;width:800px;text-align:center;margin-bottom:14px;">
          <el-pagination
            background
            @current-change="handleCurrentChange2"
            :current-page="currentPage2"
            :page-size="pageSize2"
            layout=" prev, pager, next"
            :total="totalNum2"
          ></el-pagination>
        </div>
      </div>
    </div>

    <!-- 热门课程 -->
    <div class="Course">
      <div class="title">热门课程推荐</div>
      <div v-show="a==0">
        <input
          class="search"
          placeholder="全局搜索"
          @blur="blur"
          @focus="focus"
          type="text"
          v-model="search"
        />
        <div class="search_img">
          <img @click="gosearch" src="../assets/img/search_n.png" alt />
        </div>
        <div class="h_search" v-show="show==1">
          <div class="top">
            <p>历史搜索</p>
            <p @click="deletes">
              <img src="../assets/img/search_del.png" alt /> 清空
            </p>
          </div>
          <div class="jieguo">
            <p v-for="(list , index) in h_search" :key="index" @click="xz(list)">{{list}}</p>
            <p v-show="!h_search">无</p>
          </div>
        </div>
      </div>
      <div class="recommend"></div>
      <div class="details">
        <div
          class="list"
          v-for="(good,index) in good_courses"
          :key="index"
          @click="godetails(good.id,index)"
        >
          <img :src="good.image" alt />
          <p class="title">{{good.name}}</p>
          <div class="jiage">
            <img class="touxiang" :src="good.teacher_image" alt />
            <p class="name">{{good.teacher_name}}</p>
            <p class="price" v-if="good.members_free==1">VIP免费</p>
            <p class="price" v-if="good.price!=0.00&&good.members_free==0">¥{{good.price}}</p>
            <p class="price" v-if="good.price==0.00">免费</p>
          </div>
          <div class="solid"></div>
          <div class="list-footer">
            <div class="left">
              <img src="../assets/img/se.png" alt />
              <span>{{good.sales}}</span>
            </div>
            <div class="center"></div>
            <div class="right">
              <img src="../assets/img/pl.png" alt />
              <span>{{good.number}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="more" @click="Course_more">
        查看更多
        <img src="../assets/img/r.png" alt />
      </div>
    </div>
    <!-- 关于我们 -->
    <div class="about">
      <div class="title-top">
        <div class="title"></div>
        <div class="guanyu">—— 关于我们 ——</div>
      </div>
      <div class="about-details">
        <div class="img">
          <img :src="about_img" alt />
        </div>
        <div class="weizi" v-html="about_cont">{{about_cont}}</div>
      </div>
    </div>
    <!-- 为什么 -->
    <div class="chose">
      <div class="chose-top">
        <div class="title"></div>
        <div class="title2">—— 为什么选择知会教育 ——</div>
      </div>
      <div class="chose-details">
        <div class="list" v-for="(list1,index) in about_list1" :key="index">
          <div class="blue">
            <img :src="list1.image" alt />
          </div>
          <p class="shizi">{{list1.name}}</p>
          <p class="jianjie">{{list1.intro}}</p>
        </div>
      </div>
    </div>
    <!-- 教育资源 -->
    <div class="resource">
      <div class="jiaoyuziyuan">
        <div class="left">
          <p class="title">教育资源</p>
          <p class="xiangqing">{{about_ziyuan}}</p>
        </div>
      </div>
      <div v-for="(list2,index) in about_list2" :key="index">
        <div class="juxing" v-if="index==0">
          <img :src="list2.image" alt />
          <p class="title1">{{list2.name}}</p>
          <p class="jianjie1">{{list2.intro}}</p>
        </div>
        <div class="juxing1" v-if="index==1">
          <img :src="list2.image" alt />
          <p class="title1">{{list2.name}}</p>
          <p class="jianjie1">{{list2.intro}}</p>
        </div>
        <div class="juxing2" v-if="index==2">
          <img :src="list2.image" alt />
          <p class="title1">{{list2.name}}</p>
          <p class="jianjie1">{{list2.intro}}</p>
        </div>
        <div class="juxing3" v-if="index==3">
          <img :src="list2.image" alt />
          <p class="title1">{{list2.name}}</p>
          <p class="jianjie1">{{list2.intro}}</p>
        </div>
        <div class="juxing4"></div>
        <div class="juxing5"></div>
        <div class="juxing6" v-if="index==4">
          <img :src="list2.image" alt />
          <p class="title1">{{list2.name}}</p>
        </div>
      </div>
    </div>
    <!-- 教研团队 -->
    <div class="team">
      <div class="title">教研团队</div>
      <div class="recommend"></div>
      <!-- 待定 -->
      <div class="tupian">
        <div
          class="img"
          v-for="(teacher_list,index) in teacher_lists"
          :key="index"
          @click="got_details(teacher_list.id)"
          @mouseenter="enter(index)"
          @mouseleave="leave()"
        >
          <img :src="teacher_list.avatar" alt />
          <div v-show="seen&&index==current" class="index-show">
            <div class="shadow"></div>
            <div class="cont">
              <p>{{teacher_list.nickname}}</p>
              <p class="jianjie">{{teacher_list.intro}}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="more" @click="gotopic()">
        查看更多
        <img src="../assets/img/r.png" alt />
      </div>
    </div>
    <!-- 在线报名 -->
    <div class="form">
      <div class="form-center">
        <p class="title">咨询留言</p>
        <div class="biaodan">
          <div class="details">
            <p>姓名</p>
            <input type="text" v-model="name" />
          </div>
          <div class="details">
            <p>手机</p>
            <input type="text" v-model="phone" />
          </div>
          <div class="details">
            <p>孩子年龄</p>
            <input type="text" v-model="age" />
          </div>
          <div class="details">
            <p>孩子性别</p>
            <input type="text" v-model="sex" />
          </div>
        </div>
        <div class="qita">
          <p>详细信息</p>
          <textarea
            v-model="remark"
            id="memo"
            style="min-height: 106px;min-width: 522px;max-height: 106px; max-width: 522px;"
          ></textarea>
        </div>
        <div class="btn" @click="to_sign_up">提交</div>
      </div>
    </div>
    <Login v-show="popup==1"></Login>
    <Footer></Footer>
  </div>
</template>

<script>
// 引入04/02
import Header from "./header";
import Footer from "./footer";
import Login from "./popup/login";
export default {
  name: "index",
  inject: ["reload"],
  data() {
    return {
      currentView: "",
      active: "0",
      banner1: [],
      good_courses: [],
      good_courses1: [],
      about_img: "",
      about_cont: "",
      about_list1: [],
      about_ziyuan: "",
      about_list2: [],
      name: "",
      phone: "",
      age: "",
      sex: "",
      remark: "",
      teacher_lists: [],
      seen: false,
      current: 0,
      popup: "",
      uid: "",
      search: "",
      show: "0",
      h_search: [],
      tabs: [
        {
          name: "课程",
          id: "1",
        },
        {
          name: "老师",
          id: "2",
        },
        {
          name: "评测",
          id: "3",
        },
      ],
      lists1: [],
      lists2: [],
      a: "0",
      currentPage: 1, //默认显示第一页
      pageSize: 8, //默认每页显示条
      totalNum: 0, //总页数
      currentPage1: 1, //默认显示第一页
      pageSize1: 4, //默认每页显示条
      totalNum1: 0, //总页数
      currentPage2: 1, //默认显示第一页
      pageSize2: 4, //默认每页显示条
      totalNum2: 0, //总页数
    };
  },
  created() {
    if (JSON.parse(sessionStorage.getItem("data"))) {
      var id = JSON.parse(sessionStorage.getItem("data"));
      this.uid = id.id;
    }
    this.h_search = JSON.parse(localStorage.getItem("serch"));
  },
  methods: {
    // 课程分页
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.currentPage = val; //动态改变
      this.search_course();
    },
    // 老师分页
    handleCurrentChange1(val) {
      // console.log(`当前页: ${val}`);
      this.currentPage1 = val; //动态改变
      this.search_teacher();
    },
    // 评测分页
    handleCurrentChange2(val) {
      // console.log(`当前页: ${val}`);
      this.currentPage2 = val; //动态改变
      this.search_appraisal();
    },
    //    确认框
    handleClose(done) {
      this.$confirm("请填写完整信息")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    open1() {
      this.$notify({
        title: "成功",
        message: "提交成功",
        type: "success",
      });
    },
    // banner
    async banner() {
      await this.$service.home
        .banner({ site: "1", uid: this.uid })
        .then((res) => {
          console.log(res);
          if (res.data.code == 200) {
            this.banner1 = res.data.content;
          }
        })
        .catch((err) => {
          // console.log(err);
        });
    },
    // 精品课程
    async hot_list() {
      await this.$service.home
        .hot_list({ page: 1, page_count: 8 })
        .then((res) => {
          console.log(res.data);
          if (res.data.code == 200) {
            this.good_courses = res.data.content.list;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 关于知会
    async about_list() {
      await this.$service.home
        .about_list({ page: 1, page_count: 1 })
        .then((res) => {
          console.log(res.data.content.content);
          if (res.data.code == 200) {
            // console.log(res.data.content.list2);
            this.about_img = res.data.content.image;
            this.about_cont = res.data.content.content;
            this.about_list1 = res.data.content.list1;
            this.about_ziyuan = res.data.content.intro;
            this.about_list2 = res.data.content.list2;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 教研团队
    async teacher_list() {
      await this.$service.home
        .teacher_list({ page: 1, page_count: 5 })
        .then((res) => {
          console.log(res);
          if (res.data.code == 200) {
            this.teacher_lists = res.data.content.list;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 跳转详情页
    got_details(id) {
      console.log(id);
      this.$router.push({
        path: "topic_details",
        query: {
          id: id,
        },
      });
    },
    // 在线报名
    async to_sign_up() {
      var name = this.name;
      var phone = this.phone;
      var age = this.phone;
      var sex = this.sex;
      var remark = this.remark;
      if (name != "" || phone != "" || age != "" || sex != "" || remark != "") {
        await this.$service.home
          .to_sign_up({
            name: name,
            phone: phone,
            age: age,
            sex: sex,
            remark: remark,
          })
          .then((res) => {
            if (res.code == 200) {
              this.open1();
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        this.handleClose();
      }
    },
    // banner切换
    tab(index) {
      this.$refs.carousel.setActiveItem(index);
    },
    enter(index) {
      this.seen = true;
      this.current = index;
    },
    leave() {
      this.seen = false;
      this.current = null;
    },
    // 课程查看更多
    Course_more() {
      this.$router.push({ path: "/more" });
    },
    // 跳转课程详情
    godetails(id) {
      this.$router.push({
        path: "/details",
        query: {
          id: id,
        },
      });
    },
    // 团队跳转
    gotopic() {
      this.$router.push({
        path: "/topic",
      });
    },
    // 课程搜索
    async search_course() {
      // 课程列表
      await this.$service.home
        .search_course({
          name: this.search,
          page: this.currentPage,
          page_count: this.pageSize,
        })
        .then((res) => {
          console.log(res);
          if (res.data.code == 200) {
            this.good_courses1 = res.data.content.list;
            // 向上取整数
            var totalNum = Math.ceil(res.data.content.count);
            this.totalNum = totalNum;
            if (res.data.content.list) {
              this.a = 1;
            }
          }
        });
    },
    //搜索评测列表
    async search_appraisal() {
      // 评测列表
      await this.$service.home
        .search_appraisal({
          name: this.search,
          page: this.currentPage2,
          page_count: this.pageSize2,
        })
        .then((res) => {
          console.log(res);
          if (res.data.code == 200) {
            this.lists2 = res.data.content.list;
            // 向上取整数
            var totalNum = Math.ceil(res.data.content.count);
            this.totalNum2 = totalNum;
            if (res.data.content.list) {
              this.a = 1;
            }
          }
        });
    },
    // 搜索老师
    async search_teacher() {
      // 老师
      await this.$service.home
        .search_teacher({
          name: this.search,
          page: this.currentPage1,
          page_count: this.pageSize1,
        })
        .then((res) => {
          console.log(res);
          if (res.data.code == 200) {
            this.lists1 = res.data.content.list;
            // 向上取整数
            var totalNum = Math.ceil(res.data.content.count);
            this.totalNum1 = totalNum;
            if (res.data.content.list) {
              this.a = 1;
            }
          }
        });
    },
    // 全局搜索
    async gosearch() {
      var arra = [];
      if (this.search != ``) {
        this.search_course();
        this.search_appraisal();
        this.search_teacher();
        var read = JSON.parse(localStorage.getItem("serch"));
        

        if (read != null) {
          read.push(this.search);
          var hash=[];
          for (var i = 0; i < read.length; i++) {
            if (hash.indexOf(read[i]) == -1) {
              hash.push(read[i]);
            }
          }
          localStorage.setItem("serch", JSON.stringify(hash));
        } else {
          arra.push(this.search);
          localStorage.setItem("serch", JSON.stringify(arra));
        }
      }
      this.h_search = JSON.parse(localStorage.getItem("serch"));
    },
    //获取焦点
    focus() {
      this.show = 1;
    },
    //失去焦点
    blur() {
      setTimeout(() => {
        this.show = 0;
      }, 100);
    },
    // 历史记录选择
    xz(list) {
      this.search = list;
    },
    // 删除历史记录
    deletes() {
      localStorage.clear();
      this.reload();
    },
    //切换搜索结果
    toggle(i, v) {
      if (i == undefined) {
        this.active = 0;
      } else {
        this.active = i;
        this.currentView = v;
      }
    },
  },
  components: {
    Header,
    Footer,
    Login,
  },

  mounted() {
    this.banner();
    this.hot_list();
    this.about_list();
    this.teacher_list();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
a {
  text-decoration: none;
  color: #fff;
}
.banner {
  height: 400px;
  /* background-image: url("../assets/img/timg.jpg"); */
  display: flex;
  position: relative;
  align-items: center;
}
.banner .banner-left {
  width: 100%;
  height: 400px;
  position: absolute;
}
.banner .banner-left img {
  width: 100%;
  height: 400px;
}
.banner .banner-right {
  width: 280px;
  height: 340px;
  background: rgba(0, 0, 0, 0.4);
  display: inline-flex;
  flex-wrap: wrap;
  justify-content: center;
  z-index: 99;
  margin-left: 68%;
}
.banner .banner-right ul li {
  width: 260px;
  font-size: 14px;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  line-height: 35px;
}
.banner .banner-right ul li a:hover {
  color: #71d0ff;
}
.banner .banner-right ul li.active {
  color: #71d0ff;
}
/* 热门课程 */
.Course {
  margin: 0 auto;
  width: 1200px;
  margin-top: 50px;
  position: relative;
}
.Course .title {
  width: 190px;
  height: 40px;
  font-size: 28px;
  font-family: PingFang-SC-Bold, PingFang-SC;
  font-weight: bold;
  color: rgba(23, 117, 239, 1);
  line-height: 40px;
  text-align: center;
  margin: 0 auto;
}
.Course .recommend {
  width: 198px;
  height: 22px;
  font-size: 16px;
  font-family: PingFang-SC-Medium, PingFang-SC;
  font-weight: 500;
  color: rgba(136, 136, 136, 1);
  line-height: 22px;
  letter-spacing: 1px;
  text-align: center;
  margin: 0 auto;
  margin-bottom: 28px;
}
.s_cont {
  position: relative;
}
.Course .search,
.s_cont .search {
  position: absolute;
  top: 15px;
  right: 0px;
  width: 200px;
  height: 34px;
  background: #f8f8f8;
  border: 1px solid #eeeeee;
  border-radius: 17px;
}
.Course .search_img,
.s_cont .search_img {
  position: absolute;
  top: 20px;
  right: 5px;
}
.Course .h_search,
.s_cont .h_search {
  width: 200px;
  min-height: 146px;
  background: #ffffff;
  border: 1px solid #eeeeee;
  border-radius: 4px;
  box-shadow: 0px 6px 12px 0px rgba(0, 0, 0, 0.13);
  position: absolute;
  top: 55px;
  right: 0px;
  z-index: 999;
}
.Course .h_search .top,
.s_cont .h_search .top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
  width: 180px;
  height: 40px;
  border-bottom: 1px solid #eeeeee;
}
.Course .h_search .top p,
.s_cont .h_search .top p {
  font-size: 14px;
  color: #888888;
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.Course .h_search .jieguo,
.s_cont .h_search .jieguo {
  width: 180px;
  height: 100px;
  margin: 0 auto;
  overflow: auto;
}
.Course .h_search .jieguo p,
.s_cont .h_search .jieguo p {
  font-size: 14px;
  font-family: PingFang, PingFang-SC;
  font-weight: SC;
  text-align: left;
  color: #333333;
  line-height: 20px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}
.Course .h_search .jieguo p:hover,
.s_cont .h_search .jieguo p:hover{
  background-color: #1775ef;
  color: #fff;
  border-radius: 5px;
}
.Course .details {
  display: flex;
  /* justify-content: space-between; */
  flex-wrap: wrap;
  width: 1290px;
}
.Course .list {
  margin-bottom: 48px;
  width: 270px;
  height: 340px;
  background: rgba(255, 255, 255, 1);
  border-radius: 8px;
  border: 1px solid rgba(234, 234, 234, 1);
  margin-right: 50px;
}
.Course .list img {
  width: 270px;
  height: 180px;
  border-radius: 8px;
  margin-bottom: 10px;
}
.Course .list .title {
  text-align: left;
  width: 245px;
  height: 50px;
  font-size: 18px;
  color: #333333;
  line-height: 25px;
  letter-spacing: 1px;
  margin-bottom: 10px;
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2; /*控制可显示几行文本*/
}
.Course .list .jiage {
  display: flex;
  text-align: center;
  margin: 0 8px 20px 13px;
  height: 30px;
}
.Course .list .jiage .touxiang {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  margin-right: 8px;
}
.Course .list .jiage p.name {
  min-width: 61px;
  height: 20px;
  font-size: 14px;
  color: rgba(51, 51, 51, 1);
  line-height: 4px;
  margin-right: 60px;
}
.Course .list .jiage p.price {
  /* width: 59px; */
  height: 16px;
  font-size: 18px;
  color: rgba(255, 67, 67, 1);
  line-height: 1px;
}
.Course .list .solid {
  width: 270px;
  height: 1px;
  background: rgba(234, 234, 234, 1);
}
.Course .list .list-footer {
  display: flex;
  justify-content: space-around;
}
.Course .list .list-footer .left,
.Course .list .list-footer .right {
  width: 50px;
  display: flex;
  justify-content: space-around;
  line-height: 35px;
}
.Course .list .list-footer .left img,
.Course .list .list-footer .right img {
  width: 17px;
  height: 12px;
  margin-top: 12px;
}
.Course .list .list-footer .center {
  width: 1px;
  height: 20px;
  background: rgba(234, 234, 234, 1);
  margin-top: 7px;
}
.Course .list .list-footer .right span,
.Course .list .list-footer .left span {
  width: 21px;
  height: 16px;
  font-size: 12px;
  color: rgba(136, 136, 136, 1);
}
.Course .more {
  width: 120px;
  height: 32px;
  font-size: 20px;
  font-family: PingFang-SC-Medium, PingFang-SC;
  font-weight: 500;
  color: rgba(23, 117, 239, 1);
  line-height: 32px;
  letter-spacing: 1px;
  margin: 0 auto;
  margin-bottom: 79px;
}
.Course .more img {
  font-size: 15px;
  width: 15px;
  height: 15px;
  margin-left: 5px;
}
/* 搜索结果 */
.s_cont {
  width: 1200px;
  margin: 0 auto;
}
.nav {
  display: inline-flex;
  width: 860px;
  border-bottom: 1px solid #ececec;
}
.nav .left ul li {
  width: 57px;
  display: inline-flex;
  font-size: 16px;
  font-family: PingFang, PingFang-SC;
  font-weight: SC;
  text-align: center;
  line-height: 22px;
  color: #333333;
}
.nav .left ul li.active {
  color: #1775ef;
}
/* 搜索结果老师 */
.topic {
  width: 1200px;
  height: 200px;
  background: rgba(255, 255, 255, 1);
  margin: 0 auto;
  display: flex;
  /* justify-content: space-around; */
  align-items: center;
  border-bottom: 1px solid #ededed;
  margin-top: 15px;
}
.topic .topic-left {
  width: 355px;
  height: 160px;
  display: flex;
  margin: 0 20px 0 20px;
}
.topic .topic-left .left-img {
  width: 126px;
  height: 160px;
  border-radius: 6px;
}
.topic .topic-left .topic-left-right {
  margin-left: 10px;
  width: 220px;
}
.topic .topic-left .topic-left-right .name {
  font-size: 20px;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 28px;
  letter-spacing: 1px;
  margin-bottom: 6px;
}
.topic .topic-left .topic-left-right .chenghu {
  font-size: 14px;
  font-weight: 500;
  color: rgba(136, 136, 136, 1);
  line-height: 20px;
}
.topic .topic-left .topic-left-right .jianjie {
  font-size: 14px;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 20px;
  margin-top: 26px;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  overflow: hidden;
}
.topic .topic-img {
  width: 240px;
  height: 160px;
  margin-right: 20px;
}
/* 搜索测评结果 */
.cont {
  width: 1240px;
  margin: 0 auto;
  display: flex;
  /* justify-content: space-around; */
  flex-wrap: wrap;
  align-items: center;
  margin-top: 15px;
}
.cont .list {
  width: 580px;
  height: 170px;
  background: rgba(255, 255, 255, 1);
  border-radius: 8px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  margin-right: 40px;
}
.cont .list-cont {
  height: 130px;
  width: 530px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}
.cont .list-cont img {
  width: 240px;
  height: 134px;
  margin-right: 10px;
}
.cont .list-cont .right .name {
  font-size: 18px;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  line-height: 25px;
  letter-spacing: 1px;
  text-align: center;
}
.cont .list-cont .right .price {
  font-size: 24px;
  font-weight: 500;
  color: rgba(255, 67, 67, 1);
  line-height: 26px;
  margin-top: 58px;
  margin-left: 140px;
  text-align: right;
}
/* 关于我们 */
.about {
  width: 1250px;
  height: 500px;
  margin: 0 auto;
  margin-bottom: 136px;
}
.about .title-top {
  width: 256px;
  height: 70px;
  margin: 0 auto;
  text-align: center;
  position: relative;
  margin-bottom: 23px;
}
.about .title {
  font-size: 55px;
  font-family: PingFang-SC-Medium, PingFang-SC;
  font-weight: 500;
  color: rgba(228, 240, 255, 1);
  line-height: 70px;
}
.about .guanyu {
  font-size: 25px;
  color: rgba(51, 51, 51, 1);
  line-height: 40px;
  position: absolute;
  top: -3px;
  left: 19px;
}
.about .about-details {
  display: flex;
  justify-content: space-around;
}
.about .about-details .img img {
  width: 700px;
  height: 420px;
}
.about .about-details .weizi {
  text-indent: 32px;
  width: 500px;
  font-size: 16px;
  font-family: PingFang-SC-Medium, PingFang-SC;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 30px;
  letter-spacing: 1px;
}
/* 为什么 */
.chose {
  width: 1200px;
  height: 500px;
  margin: 0 auto;
  margin-bottom: 136px;
  text-align: center;
}
.chose .chose-top {
  width: 429px;
  height: 70px;
  margin: 0 auto;
  text-align: center;
  position: relative;
  margin-bottom: 23px;
}
.chose .title {
  font-size: 55px;
  font-family: PingFang-SC-Medium, PingFang-SC;
  font-weight: 500;
  color: rgba(228, 240, 255, 1);
  line-height: 70px;
}
.chose .title2 {
  font-size: 25px;
  color: rgba(51, 51, 51, 1);
  line-height: 40px;
  position: absolute;
  top: -3px;
  left: 48px;
}
.chose .chose-details {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
}
.chose .chose-details .list {
  width: 33%;
  height: 200px;
  margin-bottom: 55px;
}
.chose .chose-details .list .blue img {
  width: 66px;
  height: 66px;
  /* background: rgba(23, 117, 239, 1); */
  margin: 0 auto;
  border-radius: 50%;
}
.chose .chose-details .list .shizi {
  font-size: 18px;
  color: rgba(51, 51, 51, 1);
  font-weight: bold;
  line-height: 25px;
  letter-spacing: 1px;
}
.chose .chose-details .list .jianjie {
  width: 217px;
  height: 60px;
  font-size: 14px;
  font-family: PingFang-SC-Medium, PingFang-SC;
  font-weight: 500;
  color: rgba(102, 102, 102, 1);
  line-height: 20px;
  margin: 0 auto;
}
/* 资源 */
.resource {
  position: relative;
  width: 1440px;
  margin: 0 auto;
}
.resource .jiaoyuziyuan {
  width: 760px;
  height: 677px;
  background: rgba(8, 98, 214, 0.06);
  border: 1px solid rgba(8, 98, 214, 0.06);
}
.resource .jiaoyuziyuan .left {
  width: 333px;
  height: 255px;
  margin: 153px 307px 272px 120px;
}
.resource .jiaoyuziyuan .left .title {
  width: 137px;
  height: 45px;
  font-size: 32px;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  line-height: 45px;
  letter-spacing: 2px;
}
.resource .jiaoyuziyuan .left .xiangqing {
  width: 333px;
  height: 180px;
  font-size: 16px;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 30px;
  letter-spacing: 1px;
}
/* 蓝色 */
.resource .juxing {
  position: absolute;
  top: 99px;
  left: 559px;
  width: 251px;
  height: 251px;
  background: rgba(23, 117, 239, 1);
  box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.08);
}
.resource .juxing img {
  margin: 45px 0 0 40px;
  width: 64px;
  height: 63px;
}
.resource .juxing .title1 {
  margin-left: 40px;
  width: 116px;
  height: 25px;
  font-size: 18px;
  font-family: PingFang-SC-Medium, PingFang-SC;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  line-height: 25px;
  letter-spacing: 1px;
}
.resource .juxing .jianjie1 {
  margin-left: 40px;
  width: 181px;
  height: 40px;
  font-size: 14px;
  font-family: PingFang-SC-Medium, PingFang-SC;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  line-height: 20px;
}
/* 橘色 */
.resource .juxing1 {
  position: absolute;
  top: 99px;
  left: 834px;
  width: 251px;
  height: 251px;
  background: rgba(255, 79, 82, 1);
  box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.08);
}
.resource .juxing1 img {
  margin: 45px 0 0 40px;
  width: 68px;
  height: 60px;
}
.resource .juxing1 .title1 {
  margin-left: 40px;
  width: 116px;
  height: 25px;
  font-size: 18px;
  font-family: PingFang-SC-Medium, PingFang-SC;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  line-height: 25px;
  letter-spacing: 1px;
}
.resource .juxing1 .jianjie1 {
  margin-left: 40px;
  width: 181px;
  height: 40px;
  font-size: 14px;
  font-family: PingFang-SC-Medium, PingFang-SC;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  line-height: 20px;
}
/* 黄色 */
.resource .juxing2 {
  position: absolute;
  top: 370px;
  left: 834px;
  width: 251px;
  height: 251px;
  background: rgba(229, 184, 99, 1);
  box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.08);
}
.resource .juxing2 img {
  margin: 45px 0 0 40px;
  width: 66px;
  height: 66px;
}
.resource .juxing2 .title1 {
  margin-left: 40px;
  width: 116px;
  height: 25px;
  font-size: 18px;
  font-family: PingFang-SC-Medium, PingFang-SC;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  line-height: 25px;
  letter-spacing: 1px;
}
.resource .juxing2 .jianjie1 {
  margin-left: 40px;
  width: 181px;
  height: 40px;
  font-size: 14px;
  font-family: PingFang-SC-Medium, PingFang-SC;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  line-height: 20px;
}
/* 褐色 */
.resource .juxing3 {
  position: absolute;
  top: 323px;
  left: 1109px;
  width: 251px;
  height: 251px;
  background: rgba(101, 85, 101, 1);
  box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.08);
}
.resource .juxing3 img {
  margin: 45px 0 0 40px;
  width: 69px;
  height: 63px;
}
.resource .juxing3 .title1 {
  margin-left: 40px;
  width: 116px;
  height: 25px;
  font-size: 18px;
  font-family: PingFang-SC-Medium, PingFang-SC;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  line-height: 25px;
  letter-spacing: 1px;
}
.resource .juxing3 .jianjie1 {
  margin-left: 40px;
  width: 181px;
  height: 40px;
  font-size: 14px;
  font-family: PingFang-SC-Medium, PingFang-SC;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  line-height: 20px;
}
/*  */
.resource .juxing4 {
  position: absolute;
  right: 5px;
  top: 39px;
  width: 154px;
  height: 251px;
  background: rgba(201, 217, 224, 1);
}
.resource .juxing5 {
  position: absolute;
  right: 190px;
  top: 49px;
  width: 68px;
  height: 68px;
  background: rgba(241, 248, 251, 1);
}
/* 小矩形 */
.resource .juxing6 {
  position: absolute;
  top: 150px;
  left: 1109px;
  width: 140px;
  height: 140px;
  background: rgba(201, 217, 224, 1);
  box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.08);
}
.resource .juxing6 img {
  margin: 25px 0 0 22px;
  width: 52px;
  height: 52px;
}
.resource .juxing6 .title1 {
  margin-left: 22px;
  width: 116px;
  height: 25px;
  font-size: 15px;
  font-family: PingFang-SC-Medium, PingFang-SC;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  line-height: 25px;
  letter-spacing: 1px;
}
/* 教研团队 */
.team {
  width: 100%;
  margin-top: 50px;
}
.team .title {
  width: 168px;
  height: 40px;
  font-size: 28px;
  font-family: PingFang-SC-Bold, PingFang-SC;
  font-weight: bold;
  color: rgba(23, 117, 239, 1);
  line-height: 40px;
  text-align: center;
  margin: 0 auto;
}
.team .recommend {
  width: 198px;
  height: 22px;
  font-size: 16px;
  font-weight: 500;
  color: rgba(136, 136, 136, 1);
  line-height: 22px;
  letter-spacing: 1px;
  text-align: center;
  margin: 0 auto;
  margin-bottom: 28px;
}
.team .tupian {
  display: flex;
  justify-content: space-between;
  margin-bottom: 58px;
}
.team .tupian .img {
  width: 320px;
  height: 380px;
  position: relative;
  margin-right: 30px;
}
.team .tupian .img:last-child {
  margin-right: 0px;
}
.team .tupian .img .shadow {
  width: 100%;
  height: 380px;
  position: absolute;
  top: 0;
  left: 0;
  background-color: #000000;
  z-index: 999;
  border-radius: 8px;
  opacity: 0.5;
  filter: alpha(opacity=50);
}
.team .tupian .img .cont {
  width: 90%;
  height: 163px;
  color: rgba(255, 255, 255, 1);
  position: absolute;
  top: 0;
  left: 15px;
  z-index: 1000;
  margin-top: 27px;
}
.team .tupian .img .cont p {
  font-size: 24px;
  font-weight: bold;
  color: rgba(255, 255, 255, 1);
}
.team .tupian .img .cont p.jianjie {
  font-size: 14px;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
}
.team .tupian .img img {
  width: auto;
  height: 380px;
  max-width: 100%;
  max-height: 380px;
  border-radius: 8px;
  z-index: 99;
}
/* 查看更多 */
.team .more {
  width: 120px;
  height: 32px;
  font-size: 20px;
  font-family: PingFang-SC-Medium, PingFang-SC;
  font-weight: 500;
  color: rgba(23, 117, 239, 1);
  line-height: 32px;
  letter-spacing: 1px;
  margin: 0 auto;
  margin-bottom: 79px;
}
.team .more img {
  font-size: 15px;
  width: 15px;
  height: 15px;
  margin-left: 5px;
}
/* 在线报名 */
.form {
  height: 700px;
  background-image: url("../assets/img/ttt.png");
  background-size: 100%;
}
.form .form-center {
  margin: 0 auto;
  width: 600px;
  height: 540px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.2);
  position: relative;
  top: 50%; /*偏移*/
  transform: translateY(-50%);
  border: 1px solid rgba(255, 255, 255, 1);
}
.form .form-center .title {
  font-size: 28px;
  color: rgba(51, 51, 51, 1);
  font-weight: bold;
  line-height: 40px;
  text-align: center;
}
.form .form-center .biaodan {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
}
.form .form-center .biaodan .details {
  width: 40%;
}
.form .form-center .biaodan .details p,
.form .form-center .qita p {
  font-weight: bold;
  font-size: 14px;
  color: rgba(51, 51, 51, 1);
  line-height: 20px;
}
.form .form-center .qita {
  width: 90%;
  margin: 0 auto;
}
.form .form-center .btn {
  text-align: center;
  line-height: 50px;
  margin: 0 auto;
  width: 522px;
  height: 50px;
  background: rgba(23, 117, 239, 1);
  margin-top: 20px;
  color: rgba(255, 255, 255, 1);
  font-size: 16px;
}
input {
  width: 246px;
  height: 36px;
  background: rgba(236, 238, 240, 1);
  border: none;
}
textarea {
  background: rgba(236, 238, 240, 1);
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue